import React from 'react';

import { RibbonStarV2 } from 'src/assets/ribbon-star-v2';
import SvgWarning from 'src/assets/warning-icon';
import { useImage } from 'hooks/use-image';
import { LoyaltyLogo, LogoWrapper } from './styles';

type IrlEventLogoProps = {
  headerImageUrl: string | null;
  showError?: boolean;
};

export function IrlEventLogo({ headerImageUrl, showError = false }: IrlEventLogoProps): JSX.Element {
  const { showImage, handleImageError } = useImage(headerImageUrl);

  return (
    <LogoWrapper $showError={showError}>
      {showError && <SvgWarning width={24} height={24} fill='#646D72' />}
      {!showError && showImage && (
        <LoyaltyLogo
          alt='Loyalty logo'
          src={headerImageUrl}
          onError={handleImageError}
          data-testid='irl-event-header-image'
        />
      )}
      {!showError && !showImage && <RibbonStarV2 />}
    </LogoWrapper>
  );
}
